<template>
  <TabView v-model:activeIndex="activeTab">
    <TabPanel header="Alarm events">
      <AlarmEvents :isFiltersOpen="isFiltersOpen"/>
    </TabPanel>
    <TabPanel header="Deleted alarms">
      <DeletedAlarms :isFiltersOpen="isFiltersOpen"/>
    </TabPanel>
    <TabPanel header="License">
      <License :isFiltersOpen="isFiltersOpen"/>
    </TabPanel>
    <TabPanel header="Repeatable monitored alarms">
      <RepeatableMonitoredAlarms :isFiltersOpen="isFiltersOpen"/>
    </TabPanel>
    <TabPanel header="Active alarms">
      <ActiveAlarms :isFiltersOpen="isFiltersOpen"/>
    </TabPanel>
  </TabView>
</template>

<script>
import {getLicenseModules} from "@/api/license";
import {getList} from "@/api/list";
import AlarmEvents from './alarm-events'
import DeletedAlarms from './deleted-alarms'
import License from './license'
import RepeatableMonitoredAlarms from './repeateble-monitores-alarms'
import ActiveAlarms from './active-alarms'

export default {
  name: "admin-panel-server-back",
  props: {
    isFiltersOpen: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AlarmEvents,
    DeletedAlarms,
    License,
    RepeatableMonitoredAlarms,
    ActiveAlarms,
  },
  mounted() {
    this.getModules();
    this.getAlarmEvents()
  },
  data() {
    return {
      activeTab: 0,
      alarmPointId: null,
      systemId: null,
      alarmEventsAlarmId: null,
      alarmEventsSystemId: null,
      deletedAlarmsAlarmId: null,
      deletedAlarmsSystemId: null,
      activeAlarmsAlarmId: null,
      activeAlarmsSystemId: null,
      isOnlyConnected: false,
      modules: [],
      alarmTableRows: 10,
      pageSize: [5, 10, 20, 50],
      currentPage: 0,
      apCurrentPage: 0,
      alarmPointMultiFilter: {
        active: "ANY",
        alarmPointId: this.alarmPointId,
        deleted: false,
        hasConfirmation: "ANY",
        hasFollowUp: "ANY",
        hasRepetition: "ANY",
        hasStandbySchedule: "ANY",
        isLifesign: "ANY",
        members: [],
        name: "",
        priority: {high: 10, low: 0},
        systemId: this.systemId,
        withAlarmPlans: "ANY",
        withAttachments: "ANY",
      }
    };
  },
  methods: {
    getModules() {
      getLicenseModules().then((res) => (this.modules = res.data));
    },
    getAlarmEvents() {
      return getList('ALARMPOINT', this.apCurrentPage, this.alarmPointSearch, this.alarmPointRows, this.orgId, this.childFilter, this.computedTab, this.isDeleted).then((response) => {
        this.alarmPoints = response.data.list.filter(function (item) {
          return !item.name.includes('mob_app');
        })

        this.apTotalRecords = response.data.count
        this.alarmPointsOriginal = response.data.list
        this.loading = false;
      })
    }
  },
};
</script>

<style scoped>
::v-deep(.p-datatable) {
  max-width: 100%;
}

::v-deep(.p-tabview-nav) {
  padding-bottom: 1px;
}
</style>
